import { render } from "./QuizType1.vue?vue&type=template&id=0abbcd09&scoped=true"
import script from "./QuizType1.vue?vue&type=script&lang=js"
export * from "./QuizType1.vue?vue&type=script&lang=js"

import "./QuizType1.vue?vue&type=style&index=0&id=0abbcd09&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0abbcd09"]])

export default __exports__